import { ReactNode } from "react";

export const LI: React.FC<{
    className?: string;
    children?: ReactNode;
}> = ({
    className,
    children,
}) => <li className={`body-copy ${className}`}>{children}</li>;